import React from 'react'
import { IoCloseOutline } from 'react-icons/io5'
import { closeModal } from '../../../features/modal/ModalSlice';
import { useDispatch } from 'react-redux';
import { FaRegEnvelope } from 'react-icons/fa6';
import { HiOutlineEnvelope } from "react-icons/hi2";
import { Link } from 'react-router-dom';
import { LuRefreshCcw } from 'react-icons/lu';

const ChangeEmail = () => {

    const dispatch = useDispatch();

    const handleClosePopup = () => {
        dispatch(closeModal());
      };

  return (
    <>
    
    




    <div className={"rightModal taskModal changeEmail"}>
      <div className="modal-header px-3 py-2">
        <h4 className="m-0">Change Email</h4>
        <button className="btnClose ms-auto" onClick={handleClosePopup}><IoCloseOutline /></button>
      </div>

      <div className="px-4 py-5 text-center">
        <span className='lgIcon'><HiOutlineEnvelope /></span>
        <h3 className='my-2'>Let's first verify your email</h3>
        <p>We'll send a verification link to your current email: <b>webdesigner.saurabh@gmail.com</b> for security confirmation</p>
        <div className="d-flex gap-4 pt-4 justify-content-center">
            <button className="btnNobg py-2">Cancel</button>
            <button className="btnSubmit py-2">Send</button>
        </div>
      </div>

      <div className="px-4 py-5 text-center d-none">
        <span className='lgIcon'><HiOutlineEnvelope /></span>
        <h3 className='my-2'>Link sent, please check your email</h3>
        <p>Didn't receive the link?</p>
        <Link className='resend'><span className='me-2'><LuRefreshCcw /></span> Resend verification link</Link>
      </div>

      <div className="px-4 py-5 text-center d-none">
        <div className='withIcon'>
            <span className='icon'><FaRegEnvelope /></span>
            <input type='text' className='form-control' placeholder='Enter your new email id' />
        </div>
        <div className="d-flex gap-4 pt-4 justify-content-center">
            <button className="btnNobg py-2">Cancel</button>
            <button className="btnSubmit py-2">Send</button>
        </div>
      </div>


    </div>
    
    
    
    
    
    </>
  )
}

export default ChangeEmail